/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { BillingPeriod } from '../models/BillingPeriod';

/**
* Response containing billing periods for the past year
*/
export class GetBillingPeriodsResponse {
  /**
  * List of billing periods sorted from newest to oldest
  */
  'periods': Array<BillingPeriod>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "periods",
      "baseName": "periods",
      "type": "Array<BillingPeriod>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return GetBillingPeriodsResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

